export const PRIMARY_COLOR = "#F92335";
export const SECONDARY_COLOR = "#00C4CC";
